import { Edit, ForkLeft, KeyboardArrowLeft, KeyboardArrowRight, Save } from "@mui/icons-material";
import { Autocomplete, Box, FormControl, IconButton, MenuItem, Select, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FaFilter } from "react-icons/fa";
import { GrPowerReset } from "react-icons/gr";
import { IoClose } from "react-icons/io5";
import { clientMasterServicer } from "../../Commen_Services/clientmaster.service";
import Popup from "reactjs-popup";
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import DeleteIcon from '@mui/icons-material/Delete';
import customToast from "../Toast/CustomToast";
interface propsHead {
    openClose: any;
    refreshGrid: any;
}

const AddClient: React.FC<propsHead> = ({ openClose, refreshGrid }) => {

    const [inputs, setInputs] = useState<any>({
        CL_CODE: '',
        CL_NAME: '',
        CL_GST_NO: '',
        CL_ADDRESS: ''
    });
    const [error, setError] = useState({
        CL_CODE: '',
        CL_NAME: '',
        CL_GST_NO: '',
        CL_ADDRESS: ''
    });
    const [productmenuList, setProductMenuList] = useState([]);
    const [productMappingPopup, setProductMappingPopup] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState<any>({ OptionName: '' });
    const [productKeyList, setProductKeyList] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = productKeyList.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(productKeyList.length / rowsPerPage);
    const displayColumns = [
        {
            "Column_name": "pK_PRD__ID",
            "Header_name": "Product Id",
            "Field_Type": "TEXT"
        },
        {
            "Column_name": "pK_KEY",
            "Header_name": "Product Key",
            "Field_Type": "TEXT"
        },
        {
            "Column_name": "pK_StoreCode",
            "Header_name": "Store Code",
            "Field_Type": "TEXTFIELD"
        },
        {
            "Column_name": "pK_EXP_DATE",
            "Header_name": "Expire Date",
            "Field_Type": "DATE"
        }
    ];


    useEffect(() => {
        const fetchDropDownMenu = async () => {
            const { data: tabledatafromAPI } = await clientMasterServicer.getProductListDropMenu();
            console.log(tabledatafromAPI);
            const transformedData = tabledatafromAPI.map((item: { [x: string]: any; }) => ({
                OptionID: item[Object.keys(tabledatafromAPI[0])[0]],
                OptionName: item[Object.keys(tabledatafromAPI[0])[1]] === undefined ? item[Object.keys(tabledatafromAPI[0])[0]] : item[Object.keys(tabledatafromAPI[0])[1]]
            }));
            setProductMenuList(transformedData);
        }
        fetchDropDownMenu();
    }, [])

    const handleChange = (event: any) => {
        const name = event.target.name;
        const value = event.target.value;
        if (name == "CL_CODE") {
            if (value !== inputs["CL_CODE"]) {
                setProductKeyList([]);
            }
            if (value.length !== 5) {
                setError((prevErrors) => ({ ...prevErrors, CL_CODE: "Please Enter Valid Code" }));
            }
            else {
                setError((prevErrors) => ({ ...prevErrors, CL_CODE: "" }));
            }
        }
        else if (name == "CL_NAME") {
            if (value?.trim() == "") {
                setError((prevErrors) => ({ ...prevErrors, CL_NAME: "Please Enter Name" }));
            }
            else {
                setError((prevErrors) => ({ ...prevErrors, CL_NAME: "" }));
            }
        }
        else if (name == "CL_GST_NO") {
            if (value?.trim() == "") {
                setError((prevErrors) => ({ ...prevErrors, CL_GST_NO: "Please Enter Valid GST NO" }));
            }
            else {
                setError((prevErrors) => ({ ...prevErrors, CL_GST_NO: "" }));
            }
        }
        else {
            if (value?.trim() == "") {
                setError((prevErrors) => ({ ...prevErrors, CL_ADDRESS: "Please Enter Valid GST NO" }));
            }
            else {
                setError((prevErrors) => ({ ...prevErrors, CL_ADDRESS: "" }));
            }
        }
        setInputs((values: any) => ({ ...values, [name]: value }))
    };

    const generateProductKey = (id: number): string => {
        return `${id}-${Math.random().toString(36).substring(2, 10).toUpperCase()}`;
    };

    const handleGenerateProductKeybtn = () => {

        const productKeyGenerateParams = {
            "cL_CODE": inputs["CL_CODE"],
            "prD_ID": selectedProduct.OptionID,
            "productKeyQTY": Number(inputs.Product_Count)
        }

        clientMasterServicer.GenerateDyanmicProductKeyList(productKeyGenerateParams).then(user => {
            if (user.statusCode == 200) {
                if (user.status === false) {
                    customToast.Warning(user.message);
                }
                else {
                    const filteredList = productKeyList.filter(item => item.pK_PRD__ID !== selectedProduct.OptionID);
                    const newProducts = user.data;
                    setProductKeyList([...filteredList, ...newProducts]);
                    setSelectedProduct({ OptionName: '' });
                    setInputs((values: any) => ({ ...values, "CS_PRD_ID": '', "Product_Count": '' }));
                    setProductMappingPopup(false);
                }
            }
        });
    };

    const closePopup = () => {
        openClose(false)
    }

    const deleteMapProduct = (data: any) => {
        const filteredList = productKeyList.filter(item => item.pK_KEY !== data.pK_KEY);
        setProductKeyList([...filteredList]);
    }

    const saveClient = () => {

        const isHasError = Object.values(error).some(val => val.trim() !== '');
        if (isHasError) {
            return;
        }
        else if (inputs["CL_CODE"].trim() == "" || inputs["CL_NAME"].trim() == "" || inputs["CL_GST_NO"].trim() == "" || inputs["CL_ADDRESS"].trim() == "") {
            if (inputs["CL_CODE"].trim() == "") {
                setError((prevErrors) => ({ ...prevErrors, CL_CODE: "Please Enter Valid Code" }));
            }
            if (inputs["CL_NAME"].trim() == "") {
                setError((prevErrors) => ({ ...prevErrors, CL_NAME: "Please Enter Name" }));
            }
            if (inputs["CL_GST_NO"].trim() == "") {
                setError((prevErrors) => ({ ...prevErrors, CL_GST_NO: "Please Enter GST NO" }));
            }
            if (inputs["CL_ADDRESS"].trim() == "") {
                setError((prevErrors) => ({ ...prevErrors, CL_ADDRESS: "Please Enter Address" }));
            }
        }
        else if (productKeyList.length == 0) {
            customToast.error("Please assign atleast one product.");
        }
        else {
            const clientData = {
                "cL_CODE": inputs["CL_CODE"],
                "cL_NAME": inputs["CL_NAME"],
                "cL_GST_NO": inputs["CL_GST_NO"],
                "cL_ADDRESS": inputs["CL_ADDRESS"],
                "productKeyLists": productKeyList
            }
            clientMasterServicer.SaveorUpdateclient(clientData).then(user => {
                if (user.statusCode == 200) {
                    if (user.status === false) {
                        //console.log(user.data);
                        customToast.Warning(user.message);
                    }
                    else {
                        customToast.success(user.message);
                    }
                }
            });
            closePopup();
        }
    }

    useEffect(() => {
        setCurrentPage(1);
    }, [productKeyList]);

    const handleStoreChange = (event: any, row: any) => {
        const { value } = event.target;
        row.pK_StoreCode = value;
    };
    return (
        <>
            <div className="pop-main">
                <div className="pop-head"><span className="pop-form">&nbsp;<FaFilter />&nbsp;&nbsp;Add Client</span></div>
                <div className="client-grid-container" >
                    <div className="grid-item">
                        <TextField id="standard-basic"
                            variant="standard"
                            name="CL_CODE"
                            value={inputs["CL_CODE"]}
                            label="Client Code"
                            error={!!error?.CL_CODE}
                            helperText={error.CL_CODE}
                            onChange={(event) => { handleChange(event); }}
                            InputProps={{
                                style: {
                                    color: '#243C5C',
                                    fontSize: '14px',
                                    width: '200px',
                                    borderColor: 'red'
                                }

                            }}
                            InputLabelProps={{
                                style: {
                                    color: '#243C5C',
                                    fontSize: '12px',
                                    borderColor: 'red',

                                },
                            }}
                            FormHelperTextProps={{
                                style: {
                                    fontSize: error.CL_CODE ? '9px' : '12px',

                                },
                            }}
                        />
                    </div>
                    <div className="grid-item">
                        <TextField id="standard-basic" variant="standard" name="CL_NAME" value={inputs["CL_NAME"]} label="Client Name"
                            onChange={(event) => { handleChange(event); }}
                            error={!!error?.CL_NAME}
                            helperText={error.CL_NAME}
                            InputProps={{
                                style: {
                                    color: '#243C5C',
                                    fontSize: '14px',
                                    width: '200px',
                                    borderColor: 'red'
                                }

                            }}
                            InputLabelProps={{
                                style: {
                                    color: '#243C5C',
                                    fontSize: '12px',
                                    borderColor: 'red',

                                },
                            }}
                            FormHelperTextProps={{
                                style: {
                                    fontSize: error.CL_NAME ? '9px' : '12px',

                                },
                            }}

                        />
                    </div>
                    <div className="grid-item">
                        <TextField id="standard-basic" variant="standard" name="CL_GST_NO" value={inputs["CL_GST_NO"]} label="GST NO"
                            onChange={(event) => { handleChange(event); }}
                            error={!!error?.CL_GST_NO}
                            helperText={error.CL_GST_NO}
                            InputProps={{
                                style: {
                                    color: '#243C5C',
                                    fontSize: '14px',
                                    width: '200px',
                                    borderColor: 'red'
                                }

                            }}
                            InputLabelProps={{
                                style: {
                                    color: '#243C5C',
                                    fontSize: '12px',
                                    borderColor: 'red',

                                },
                            }}
                            FormHelperTextProps={{
                                style: {
                                    fontSize: error.CL_GST_NO ? '9px' : '12px',

                                },
                            }}

                        />
                    </div>
                    <div className="grid-item">
                        <TextField id="standard-basic" variant="standard" name="CL_ADDRESS" value={inputs["CL_ADDRESS"]} label="Client Address"
                            onChange={(event) => { handleChange(event); }}
                            error={!!error?.CL_ADDRESS}
                            helperText={error.CL_ADDRESS}
                            InputProps={{
                                style: {
                                    color: '#243C5C',
                                    fontSize: '14px',
                                    width: '200px',
                                    borderColor: 'red'
                                }

                            }}
                            InputLabelProps={{
                                style: {
                                    color: '#243C5C',
                                    fontSize: '12px',
                                    borderColor: 'red',

                                },
                            }}
                            FormHelperTextProps={{
                                style: {
                                    fontSize: error.CL_ADDRESS ? '9px' : '12px',

                                },
                            }}
                        />
                    </div>
                    <div className="grid-item">
                        <button className={`btn123 `} onClick={() => {
                            if (inputs["CL_CODE"]?.trim() !== "" && error.CL_CODE == "") {
                                setProductMappingPopup(true);
                            }
                            else {
                                setError((prevErrors) => ({ ...prevErrors, CL_CODE: "Please Enter Valid Code" }));
                            }
                        }} style={{ padding: 14, backgroundColor: 'var(--body-main-dark-color)', color: '#fff' }}>Assign Product</button>

                    </div>
                </div>

                <div className="p-4 font-sans" style={{ padding: '15px' }}>
                    <table
                        style={{
                            marginTop: "10px",
                            width: "99%",
                            borderCollapse: "collapse",
                            boxShadow: '0px 5px 9px 0px rgba(87, 86, 86, 0.66)',
                        }}
                    >
                        <thead>
                            <tr style={{ color: 'var(--body-main-dark-color)', backgroundColor: 'var(--body-main-light-color)', fontSize: '13px', fontWeight: 'bold' }}>
                                {displayColumns.map(col => (
                                    <td
                                        key={col.Column_name}
                                        className="border px-4 py-2 cursor-pointer bg-gray-100"
                                        style={{ padding: "5px" }}
                                    >
                                        {col.Header_name || col.Column_name}
                                    </td>

                                ))}
                                <td></td>
                            </tr>
                        </thead>
                        <tbody style={{ background: 'var(--button-color-light)' }}>
                            {currentRows.map((row, idx) => (
                                <tr key={idx} className="odd:bg-white even:bg-gray-50">
                                    {displayColumns.map(col => {
                                        if (col.Field_Type == 'DATE') {
                                            return (
                                                <td key={col.Column_name} className="border px-4 py-2"
                                                    style={{ padding: "5px", fontSize: "13px" }}>
                                                    {new Date(row[col.Column_name]).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        hour12: true,
                                                    })}
                                                </td>
                                            )
                                        }
                                        else if (col.Field_Type === 'TEXTFIELD') {
                                            return (
                                                <td key={col.Column_name} className="border px-4 py-2"
                                                    style={{ padding: "5px", fontSize: "13px" }}>

                                                    <TextField
                                                        variant="standard"
                                                        name={col.Column_name}
                                                        onChange={(event) => handleStoreChange(event, row)}
                                                        InputProps={{
                                                            style: {
                                                                color: '#243C5C',
                                                                fontSize: '14px',
                                                                width: '100px',
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: '#243C5C',
                                                                fontSize: '12px',
                                                            },
                                                        }}
                                                        FormHelperTextProps={{
                                                            style: {
                                                                //fontSize: error?.[col.Column_name] ? '9px' : '12px',
                                                            },
                                                        }}
                                                    />

                                                </td>
                                            )
                                        }
                                        else {
                                            return (
                                                <td key={col.Column_name} className="border px-4 py-2"
                                                    style={{ padding: "5px", fontSize: "13px" }}>
                                                    {row[col.Column_name]}
                                                </td>
                                            )
                                        }

                                    }
                                    )}
                                    <td>
                                        <IconButton aria-label="select" sx={{ color: 'var(--body-main-dark-color)' }}><Edit /></IconButton>
                                        <IconButton aria-label="select" sx={{ color: 'var(--body-main-dark-color)' }} onClick={() => deleteMapProduct(row)}><DeleteIcon /></IconButton>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                    <div className="pagination-container" style={{ background: 'var(--button-color-light)', boxShadow: '0px 5px 9px 0px rgba(87, 86, 86, 0.66)', width: '99%', color: 'var(--sidebar-bg-dark)', fontSize: '13px', padding: '10px 0px 10px 0px' }}>
                        <Box sx={{ flexShrink: 0, ml: 2.5 }}>

                            Rows per Page &nbsp;&nbsp;&nbsp;
                            <FormControl variant="standard" sx={{ minWidth: 20, }}>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={rowsPerPage}
                                    onChange={(e) => setRowsPerPage(e.target.value)}
                                    disabled={true}
                                >
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={30}>30</MenuItem>
                                </Select>
                            </FormControl>
                            <span> &nbsp;&nbsp;{indexOfFirstRow + 1} - {indexOfLastRow}&nbsp;&nbsp; of &nbsp;&nbsp; {productKeyList.length}</span>
                            <IconButton
                                onClick={() => setCurrentPage(1)}
                                disabled={currentPage === 0}
                                aria-label="first page"
                            >
                                <FirstPageIcon />
                            </IconButton>
                            <IconButton
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 0}
                                aria-label="previous page"
                            >
                                <KeyboardArrowLeft />

                            </IconButton>
                            <IconButton
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                                aria-label="next page"
                            >
                                <KeyboardArrowRight />
                            </IconButton>
                            <IconButton
                                onClick={() => setCurrentPage(Math.max(0, Math.ceil(productKeyList.length / rowsPerPage)))}
                                disabled={currentPage === totalPages}
                                aria-label="last page"
                            >
                                <LastPageIcon />
                            </IconButton>
                        </Box>
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px 20px' }}>
                    <div>
                        <button className='btn1' ><span><GrPowerReset /></span>Reset</button>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <button className='btn123' onClick={(event) => { event.stopPropagation(); saveClient() }} style={{ paddingRight: 12, height: '30px' }}><Save /> &nbsp;Save</button>&nbsp;
                        <button className='btn123' onClick={(event) => { event.stopPropagation(); closePopup() }} style={{ paddingRight: 12, height: '30px' }}><IoClose />&nbsp;Close</button>
                    </div>
                </div>
            </div>

            {productMappingPopup && (
                <Popup contentStyle={{ width: '40%', padding: 0 }} position='top center' open={productMappingPopup} onClose={() => setProductMappingPopup(false)} closeOnDocumentClick={false}>
                    <>
                        <div className="pop-main" onClick={(e) => e.stopPropagation()}>
                            <div className="pop-head" style={{ display: 'flex', justifyContent: 'space-between' }}><span className="pop-form" style={{ marginTop: '0%' }}>&nbsp;<FaFilter />&nbsp;&nbsp;Assign Product</span><button onClick={(event) => { event.stopPropagation(); setProductMappingPopup(false); setSelectedProduct({ OptionName: '' }); setInputs((values: any) => ({ ...values, "CS_PRD_ID": '', "Product_Count": '' })); }} style={{ paddingRight: 12, height: '30px', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}><IoClose /></button></div>
                            <div className="client-grid-container" >
                                <div className="grid-item">
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        options={productmenuList}
                                        value={selectedProduct}
                                        onChange={(event, newValue: any) => {
                                            setInputs((values: any) => ({ ...values, "CS_PRD_ID": newValue != null ? newValue.OptionID : '' }));
                                            setSelectedProduct(newValue);
                                        }}
                                        getOptionLabel={(option: any) => option.OptionName}
                                        isOptionEqualToValue={(option, value) => option.OptionName === value.OptionName}
                                        sx={{ width: 200, overflowY: 'auto', overflowX: 'hidden' }}
                                        renderOption={(props, option, index) => {

                                            return (
                                                <Box component="li" {...props} >
                                                    {option.OptionName}
                                                </Box>
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Product List"
                                                variant="standard"
                                                name="CS_PRD_ID"
                                                InputLabelProps={{
                                                    style: {
                                                        color: '#243C5C',
                                                        fontSize: '12px',
                                                        borderColor: 'red',

                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="grid-item">
                                    <TextField id="standard-basic" variant="standard" name="Product_Count" value={inputs["Product_Count"]} label="Product Count"
                                        onChange={(event) => { handleChange(event); }}
                                        InputProps={{
                                            style: {
                                                color: '#243C5C',
                                                fontSize: '14px',
                                                width: '100px',
                                                borderColor: 'red'
                                            }

                                        }}
                                        InputLabelProps={{
                                            style: {
                                                color: '#243C5C',
                                                fontSize: '12px',
                                                borderColor: 'red',

                                            },
                                        }}
                                    />
                                </div>
                                <div className="grid-item">
                                    <button className={`btn123 `} onClick={() => {
                                        handleGenerateProductKeybtn();
                                    }} style={{ padding: 14, backgroundColor: 'var(--body-main-dark-color)', color: '#fff', width: 'fitcontent' }}>Generate&nbsp;Product&nbsp;Key</button>
                                </div>
                            </div>
                        </div>
                    </>
                </Popup>

            )}
        </>
    );
}

export default AddClient;